function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\t.st0{fill:#FFFFFF;}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M59.6,73.6c10.1,2.4,18.8-1,27.3-6.1c6.5-4,13.1-3,19.2,1.1c3.7,2.5,7,5.6,10,10.4c-10.9-4.9-19.9-1.6-28.8,3.4 C78,87.6,67.6,83.9,59.6,73.6L59.6,73.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.5,7.5c35.9,0,71.9,0,107.8-0.1c2.6,0,2.9,0.9,2.9,3.2c-0.2,7.6-0.1,15.3-0.5,23.2 c-7.4-15.5-21-17.7-35.7-17.5c-6.3,0.1-12.7,0.2-19-0.1c-3.9-0.2-5.1,0.9-5.1,4.9C57.1,46,57,70.8,57,95.6c0,14-0.2,28,0.1,41.9 c0.2,10.2,2.4,19.5,14.1,24.7c-21.3,0-41.3,0-62.1,0c10.9-5.4,13.4-14.9,13.5-24.8c0.3-35.6,0.3-71.2,0.1-106.8 C22.5,19.7,16.6,12.2,6.5,7.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M252.7,162.5c-8-1.3-15.6-4-22.6-8.3c6.2,0.9,12.3,1.9,18.5,2.6c10.3,1.1,20.6,1.3,30.6-2 c17.8-5.9,22.2-24.6,8.7-37.8c-8.3-8.1-18.6-13.3-28.3-19.3c-9.3-5.8-18.9-11.2-25.9-19.9C214.8,54.4,223.2,15,258.1,7.2 c20.8-4.5,42.5,5.3,53.4-0.1c0,11.7,0,23.3,0,35.2c-1.7-0.8-1.8-2.2-2.4-3.3c-8.8-16.8-22.4-25.5-41.6-24.4 c-9.4,0.6-17.2,4.6-20.8,13.8c-3.5,8.9,0.3,16.2,6.7,22.3c1.3,1.3,2.7,2.4,4.3,3.4c8.9,5.8,17.8,11.6,26.9,17.1 c25.4,18.5,35.9,28.1,35.9,52.9s-17.5,35.3-34.7,37.8C282.5,162.6,263.9,164.3,252.7,162.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M141.3,7.8c21.1,0,40.8,0,61.7,0c-13.5,6.8-15.9,18.1-15.9,30.6c0,32.5,0,64.9,0,97.4c0,3.3,0.2,6.7,0.7,9.9 c1.2,6.7,3.5,12.8,11.3,16.4c-19.3,0-37.4,0-56.4,0c10.5-5,13.6-14,13.7-23.7c0.3-36.3,0.3-72.6,0-108.9 C156.4,20,152.6,11.9,141.3,7.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325 171",
    style: {
      enableBackground: "new 0 0 325 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a185da57fb493dc7f90f29051c5a39fa.svg";
export { ForwardRef as ReactComponent };